/**
 * QRMaps Design System - Spacing Tokens
 *
 * Consistent spacing scale for margins, padding, gaps, etc.
 * Based on 4px base unit (common in Material Design and most design systems)
 */

export const spacing = {
  // Numeric scale (multiplier of 4px)
  0: '0',
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '20px',
  6: '24px',
  7: '28px',
  8: '32px',
  9: '36px',
  10: '40px',
  12: '48px',
  14: '56px',
  16: '64px',
  20: '80px',
  24: '96px',
  28: '112px',
  32: '128px',

  // Semantic spacing names (for easier reading)
  none: '0',
  xxs: '2px',
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
  xxxl: '64px',

  // Component-specific spacing (extracted from current usage)
  padding: {
    button: '8px 16px',
    card: '16px',
    modal: '24px',
    sidebar: '20px',
  },

  gap: {
    tight: '4px',
    normal: '8px',
    relaxed: '16px',
    loose: '24px',
  },
};